import { CloseOutlined } from "@ant-design/icons";
import { Pause } from "react-feather";

import "./stylesSuspendModal.css";
import { Input, Select } from "antd";
import { useState } from "react";

function SuspendModal({ handleCancel }) {
  const [formData, setFormData] = useState({
    filterSegment: null,
    minTransactions: "",
  });

  const handleFieldChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <div className="suspend-modal-container">
      <div className="modal-header">
        <div className="modal-header-title">
          <Pause size={20} />
          <h2 className="modal-title"> User Suspension</h2>
        </div>
        <CloseOutlined onClick={handleCancel} className="close-icon" />
      </div>

      <div className="divider" />

      <div className="modal-content">
        <div className="transaction-info-item">
          <span>Reason</span>
          <Select
            value={formData.filterSegment}
            onChange={(value) => handleFieldChange("filterSegment", value)}
            options={[
              { value: "Suspected activity", label: "Suspected activity" },
              { value: "Spamming", label: "Spamming" },
              { value: "Fraud", label: "Fraud" },
              { value: "Other", label: "Other" },
            ]}
          />
        </div>
        <div className="transaction-info-item">
          <Input.TextArea
            type="text"
            value={formData.minTransactions}
            maxLength={255}
            rows={3}
            onChange={(e) =>
              handleFieldChange("minTransactions", e.target.value)
            }
          />
          <span className="max-length">
            {formData.minTransactions.length}/255
          </span>
        </div>
      </div>

      <div className="divider" />
      <div className="modal-footer">
        <div className="buttons">
          <button className="cancel-button" onClick={handleCancel}>
            Close
          </button>
          <button
            className="save-button"
            onClick={() => {
              console.log("Form Data:", formData);
              // Aqui você pode enviar os dados para sua API
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default SuspendModal;
